export default __webpack_public_path__ + "static/media/sony-wi-c200.a32f5efa.png";